module.exports = __webpack_public_path__ + "static/media/logout.7e4b34b1.svg";